import { ApiParameters } from './api-parameters';
import { ApiPutRequest } from './api-put-request';

export class RecurringVippsPaymentRequest extends ApiPutRequest
{
    public constructor(
        orderId: number,
        vippsId: number,
        webapiBasepath: string
    )
    {
        super(  'RecurringVippsSale', 
                new ApiParameters(), 
                null, 
                {
                    orderId,
                    vippsId
                },
                webapiBasepath
            );
    }
}
